import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import AllEntitiesPieCharts from "../../../components/Table/Dashboard/AllEntities/AllEntitiesPieCharts";
import CustomStackedBarChart from "../../../components/Table/Dashboard/AllEntities/CustomStackedBarChart";
import { useAllUsersDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllUsers";
import { Spinner } from "../../../components/Loading/Spinner";
import PickSuborg from "../../../components/Table/Dashboard/AllEntities/PickSuborg";

const AllUsersDashboard = () => {
  const {
    isLoadingTotalCredits,
    totalCredits,
    totalCreditsFilters,
    handleToggleCredit,
  } = useAllUsersDashboard();

  if (isLoadingTotalCredits) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <SelectTypeOfDashboard routeValue="users">
      <PickSuborg />
      <AllEntitiesPieCharts
        credits={totalCredits}
        title="Total usuarios"
        label="email"
      />
      <CustomStackedBarChart
        credits={totalCredits}
        label="email"
        id="id_usuario"
        totalCreditsFilters={totalCreditsFilters}
        handleToggleCredit={handleToggleCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default AllUsersDashboard;
